import type { ISocialOffer } from "@bbj-types/offer";
import EditIcon from "@mui/icons-material/EditOutlined";
import { Button, Stack } from "@mui/material";
import type { ISocialOfferWithFavoriteChallenges } from "@root/api/services/offers/socialOffer/types";
import { isInternalOfferSource } from "@root/utils/enums/offer";
import { TypoTooltip, useAuthorizer, useModalSocialOfferContext } from "@styleguide";
import clsx from "clsx";
import type { Dispatch, SetStateAction } from "react";
import { classes } from "../styles";

interface ISocialOfferHeaderProps {
  offer: ISocialOffer;
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
  onUpdate?: (offer: ISocialOfferWithFavoriteChallenges) => void;
}

export const SocialOfferHeader = ({ offer, setIsModalOpen, onUpdate }: ISocialOfferHeaderProps) => {
  const openModalSocialOffer = useModalSocialOfferContext();
  const manualOffer = isInternalOfferSource(offer.source);
  const isAuthorizedModify = useAuthorizer(["candidate.socialboard.modify"]);
  return (
    <Stack
      className={clsx(classes.section, classes.title)}
      sx={{ position: "relative", alignItems: "center", justifyContent: "space-between" }}
    >
      <TypoTooltip variant="h2">{offer.name}</TypoTooltip>
      {manualOffer && isAuthorizedModify && (
        <Button
          size="small"
          sx={{
            minWidth: "32px",
            width: "32px",
            height: "32px",
            padding: 0,
            borderRadius: "50%",
          }}
          onClick={() => {
            if (setIsModalOpen) {
              setIsModalOpen(true);
            } else {
              openModalSocialOffer(offer as ISocialOfferWithFavoriteChallenges, onUpdate);
            }
          }}
        >
          <EditIcon fontSize="small" />
        </Button>
      )}
    </Stack>
  );
};
